import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class UserRouteViewForm extends CerFormAdapter {

  public override view(): CerFormView {
    const dataApiParams = this?.routeOptions?.callerData?.url?.length > 0 ? ['$myUrlFilterEq=' + this?.routeOptions?.callerData?.url] : [];
    return new CerFormView({
      title: 'Visninger',
      autoFocus: 'active',
      mandatory: true,
      viewType: 'list',
      viewMetadata: {
        name: 'bruger-visninger',
        dataApiName: 'AppUserRouteView', dataApiParams: dataApiParams,
        text: 'Visninger', textSingular: 'Visning', titleFields: ['name'],
        primaryKey: 'id', allowEdit: true, allowCreate: false, allowDelete: true, baseFields: ['id']
      },
      fieldMetadata:[
        { name: 'id', text: 'Id', tooltipText: 'Unik nøgle for posten', visible: false },
        { name: 'name', text: 'Visning', orderBy: 'Ascending', orderByPriority: 2 },
        { name: 'isPrimary', text: 'Primær?', format: 'CheckBox', tooltipText: 'Primær visning?', orderBy: 'Ascending', orderByPriority: 1 },
        { name: 'isDefault', text: 'Valgt ved opstart?', format: 'CheckBox', tooltipText: 'Brug visning ved opstart?' },
        { name: 'created', text: 'Oprettet', format: 'DateLong', allowEdit: false, visibleAdd: false, visibleEdit: false },
        { fieldType: 'createdBy', foreignKeyType: 'user', visible: false }
      ],
      listSelectionMode: "row"
    });
  }

}
